import { api, apiFuture, apiX, v2 } from '.'

export const getCarousel = () => v2.get('public/carousel/list').json()
export const getNotice = () => v2.get('public/notic/latest/list').json()
export const queryMutCandlestick = searchParams => apiFuture.get('futureQuot/queryCandlestickList', { searchParams }).json()
export function queryKlineList(searchParams) {
  const fn = import.meta.env.VITE_ENV === 'PROD' ? apiFuture : apiX
  return fn.get('v1/market/klineList', { searchParams }).json()
}
/* 获取app配置信息 */
export const getAppDataList = () => v2.get('public/app/getAppDataList').json()

export const getPartner = () => api.get('v1/config/homePartner').json()

export const getHomeTickers = searchParams => apiFuture.get('configs/homeTickers', { searchParams }).json()

/* 获取最新币对 */
export const getLatestSymbols = () => v2.get('public/config/latest/symbols').json()

// ctc生态榜
export const getCtcEcoList = () => v2.get('public/config/ctc/symbols').json()

// 主页标语
export const getSlogan = () => v2.post('public/slogan/main', { ignoreMessage: 1 }).json()
